import React from "react";
import { Link, useLocation } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import {
  IonContent,
  IonPage,
  isPlatform,
  IonHeader,
  IonToolbar,
  IonButton,
  IonButtons,
  IonTitle,
  IonIcon,
} from "@ionic/react";
import { chevronBackOutline } from "ionicons/icons";
import { FormattedMessage } from "react-intl";
import { useIntl } from "react-intl";

// Styles
import headerStyles from "../../theme/header.module.css";
import layoutStyles from "./layout.module.css";

type AiLayoutProps = {
  children: React.ReactNode;
};

const isMobile = isPlatform("android") || isPlatform("ios");

export default function AiLayout({ children }: AiLayoutProps) {
  const location = useLocation();
  const path = location.pathname;
  const intl = useIntl();

  const paths = [
    {
      url: "/leads/leads",
      label: "nav.leads",
      header: "leads.pageTitle",
      active: path === "/leads/leads",
    },
    {
      url: "/leads/payments",
      label: "nav.payments",
      header: "leads.payments.pageTitle",
      active: path === "/leads/payments",
    },
  ];

  const selectedPath = paths.find((item) => item.active);

  const MobileTitle = ({
    backButton,
    id,
  }: {
    backButton: string;
    id: string;
  }) => {
    return (
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton
              routerLink="/menu"
              routerDirection="back"
              fill="clear"
              size="small"
              aria-label="Atrás"
            >
              <IonIcon slot="icon-only" icon={chevronBackOutline} />
              <span className="fs-4">{backButton}</span>
            </IonButton>
          </IonButtons>
          <IonTitle>
            <FormattedMessage id={id} />
          </IonTitle>
        </IonToolbar>
      </IonHeader>
    );
  };

  return (
    <IonPage id="main-content">
      {isMobile && (
        <MobileTitle
          backButton={intl.formatMessage({ id: "common.back" })}
          id={selectedPath?.header || paths[0].header}
        />
      )}
      <IonContent
        {...(isMobile
          ? { fullscreen: true, color: "light", className: "ion-padding" }
          : {})}
      >
        <div
          className={isMobile ? "view-wrapper" : "page-wrapper container-fluid"}
        >
          {!isMobile && (
            <div>
              <h1 className={headerStyles.pageTitle}>
                <FormattedMessage
                  id={selectedPath?.header || paths[0].header}
                />
              </h1>
            </div>
          )}
          <Nav defaultActiveKey="/leads/leads" className={layoutStyles.nav}>
            {paths.map((item) => (
              <Nav.Item key={item.url}>
                <Nav.Link as={Link} to={item.url} active={item.active}>
                  <FormattedMessage id={item.label} />
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
          {children}
        </div>
      </IonContent>
    </IonPage>
  );
}
